module.exports = __webpack_public_path__ + "img/caiji-type-1-4.e1068909.png";